/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement } from 'react';
import Header from 'components/layout/Header/Header';
import { YMInitializer } from 'react-yandex-metrika';

export interface Properties {
	children: any;
}

export default function MainLayout({ children }: Properties): ReactElement {
	return (
		<div className='flex min-h-screen flex-col'>
			<YMInitializer accounts={[99448466]} />
			<Header />
			{children}
		</div>
	);
}

MainLayout.defaultProps = {
	type: 'full-width'
};
